/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileServiceGetFileDetailsResponse
 */
export interface FileServiceGetFileDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof FileServiceGetFileDetailsResponse
     */
    fileId?: string;
    /**
     * 
     * @type {string}
     * @memberof FileServiceGetFileDetailsResponse
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileServiceGetFileDetailsResponse
     */
    fileSizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof FileServiceGetFileDetailsResponse
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FileServiceGetFileDetailsResponse
     */
    createdDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof FileServiceGetFileDetailsResponse
     */
    data?: string | null;
}

/**
 * Check if a given object implements the FileServiceGetFileDetailsResponse interface.
 */
export function instanceOfFileServiceGetFileDetailsResponse(value: object): value is FileServiceGetFileDetailsResponse {
    return true;
}

export function FileServiceGetFileDetailsResponseFromJSON(json: any): FileServiceGetFileDetailsResponse {
    return FileServiceGetFileDetailsResponseFromJSONTyped(json, false);
}

export function FileServiceGetFileDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileServiceGetFileDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileSizeBytes': json['fileSizeBytes'] == null ? undefined : json['fileSizeBytes'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function FileServiceGetFileDetailsResponseToJSON(json: any): FileServiceGetFileDetailsResponse {
    return FileServiceGetFileDetailsResponseToJSONTyped(json, false);
}

export function FileServiceGetFileDetailsResponseToJSONTyped(value?: FileServiceGetFileDetailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileId': value['fileId'],
        'fileName': value['fileName'],
        'fileSizeBytes': value['fileSizeBytes'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'data': value['data'],
    };
}

